export enum GenderStatusEnum {
  Male = 'male',
  Female = 'female',
  Unknown = 'unknown',
  Undefined = 'undefined',
}
